/**
 * ...
 * @author fpinn
 */
/**
 * package: com.inq.flash.client.chatskins
 * class: FocusMonitor
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.FocusMonitor = function() {
};
$hxClasses['com.inq.flash.client.chatskins.FocusMonitor'] = com.inq.flash.client.chatskins.FocusMonitor;
/** @private @type {Array} */
com.inq.flash.client.chatskins.FocusMonitor.__name__ = ["com","inq","flash","client","chatskins","FocusMonitor"];

/**
 * init
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function init():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.FocusMonitor.init = function() {
	com.inq.flash.client.chatskins.FocusMonitor.clientWin = window.parent;
	com.inq.flash.client.chatskins.FocusMonitor.clientDoc = window.parent.doc;
	
	if(com.inq.flash.client.chatskins.FocusMonitor.clientWin.name != "_inqPersistentChat") return false;
	
	try {
		/** @type {string} */
		var sChatNeedsFocusInterval;
		com.inq.flash.client.chatskins.FocusMonitor._sTitleBarText = com.inq.utils.Util.getConfig("sPersistentFrameTitle","Chat");
		com.inq.flash.client.chatskins.FocusMonitor._sTitleBarFlashText = com.inq.utils.Util.getConfig("sChatNeedsFocusTitle","**********");
		sChatNeedsFocusInterval = com.inq.utils.Util.getConfig("iChatNeedsFocusInterval","2000");
		try {
			com.inq.flash.client.chatskins.FocusMonitor._timerInterval = Std.parseInt(sChatNeedsFocusInterval);
		} catch( e ) {
			if( js.Boot.__instanceof(e,Error) ) {
				com.inq.flash.client.chatskins.FocusMonitor._timerInterval = 2000;
			} else throw(e);
		}
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
		} else throw(e);
	}
	com.inq.utils.Capabilities.BindListener(window, "focus", com.inq.flash.client.chatskins.FocusMonitor.whenFocus);
	com.inq.utils.Capabilities.BindListener(window, "blur", com.inq.flash.client.chatskins.FocusMonitor.whenBlur);

	return true;
};


/**
 * isFocused
 *
 * $type TFun([],TEnum(Bool,[]))
 * public  static function isFocused()
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.FocusMonitor.isFocused = function() {
	return com.inq.flash.client.chatskins.FocusMonitor._bFocused;
};


/**
 * toggleTitlebar
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function toggleTitlebar()
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.FocusMonitor.toggleTitlebar = function() {
	/** @type {string} */
	var ttl = window.parent.document.title;
	window.parent.document.title = ttl != com.inq.flash.client.chatskins.FocusMonitor._sTitleBarFlashText?com.inq.flash.client.chatskins.FocusMonitor._sTitleBarFlashText:com.inq.flash.client.chatskins.FocusMonitor._sTitleBarText;
};


/**
 * startTitlebarFlash
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function startTitlebarFlash()
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.FocusMonitor.startTitlebarFlash = function() {
	if(com.inq.flash.client.chatskins.FocusMonitor.clientWin.name != "_inqPersistentChat") return;
	if(com.inq.utils.Util.getConfig("divSkin", false) == true) {
		return
	}
	if(com.inq.flash.client.chatskins.FocusMonitor._timer != -1) return;
	window.parent.document.title = com.inq.flash.client.chatskins.FocusMonitor._sTitleBarFlashText;
	com.inq.flash.client.chatskins.FocusMonitor._timer = window.setInterval(com.inq.flash.client.chatskins.FocusMonitor.toggleTitlebar,com.inq.flash.client.chatskins.FocusMonitor._timerInterval);
};


/**
 * stopTitlebarFlash
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function stopTitlebarFlash()
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.FocusMonitor.stopTitlebarFlash = function() {
	if(com.inq.flash.client.chatskins.FocusMonitor._timer != -1) window.clearInterval(com.inq.flash.client.chatskins.FocusMonitor._timer);
	com.inq.flash.client.chatskins.FocusMonitor._timer = -1;
	window.parent.document.title = com.inq.flash.client.chatskins.FocusMonitor._sTitleBarText;
};


/**
 * whenBlur
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private static function whenBlur(e:Dynamic):Bool
 * @private
 * @static
 * @param {null}  e 
 * @return {boolean}
 */
com.inq.flash.client.chatskins.FocusMonitor.whenBlur = function(e) {
	if(com.inq.flash.client.chatskins.FocusMonitor._bFocused) haxe.Log.trace("lost focus",{ fileName : "FocusMonitor.hx", lineNumber : 84, className : "com.inq.flash.client.chatskins.FocusMonitor", methodName : "whenBlur"});
	com.inq.flash.client.chatskins.FocusMonitor._bFocused = false;
	return true;
};


/**
 * whenFocus
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private static function whenFocus(e:Dynamic):Bool
 * @private
 * @static
 * @param {null}  e 
 * @return {boolean}
 */
com.inq.flash.client.chatskins.FocusMonitor.whenFocus = function(e) {
	if(!com.inq.flash.client.chatskins.FocusMonitor._bFocused) haxe.Log.trace("gained focus",{ fileName : "FocusMonitor.hx", lineNumber : 92, className : "com.inq.flash.client.chatskins.FocusMonitor", methodName : "whenFocus"});
	com.inq.flash.client.chatskins.FocusMonitor.stopTitlebarFlash();
	com.inq.flash.client.chatskins.FocusMonitor._bFocused = true;
	return true;
};

/** @type {com.inq.flash.client.chatskins.FocusMonitor} */
com.inq.flash.client.chatskins.FocusMonitor.prototype.__class__ = com.inq.flash.client.chatskins.FocusMonitor;
/** @private @type {null} */
com.inq.flash.client.chatskins.FocusMonitor.clientWin = null;

/** @private @type {null} */
com.inq.flash.client.chatskins.FocusMonitor.clientDoc = null;

/** @private @type {number} */
com.inq.flash.client.chatskins.FocusMonitor._timerIdScroll = -1;

/** @private @type {boolean} */
com.inq.flash.client.chatskins.FocusMonitor._bFocused = true;

/** @private @type {string} */
com.inq.flash.client.chatskins.FocusMonitor._sTitleBarText = "Let's Chat";

/** @private @type {string} */
com.inq.flash.client.chatskins.FocusMonitor._sTitleBarFlashText = "<<<<<>>>>>";

/** @private @type {number} */
com.inq.flash.client.chatskins.FocusMonitor._timerInterval = 2000;

/** @private @type {number} */
com.inq.flash.client.chatskins.FocusMonitor._timer = -1;

